<template>
    <div>

        <div v-if="issueLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div v-if="!issue && issueLoading === false">
            <div class="row pb-4">
                <div class="col-md-8">
                    <h2 class="page-header-title">Sorry...</h2>
                </div>
            </div>
            <div class="widget">
                <div class="widget-body">
                    <p>The issue could not be found. Please check the URL and try again.</p>
                    <p> <router-link to="/">Return Home</router-link></p>
                </div>
            </div>
        </div>

        <div v-if="!issueLoading && issue">

            <div class="row pb-4">
                <div class="col-md-10">
                    <h2 class="page-header-title">
                        <router-link to="/fire-stopping-reports">
                        Fire Stopping Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'fire-stopping-report-view', params: {action: 'view', id: fireStoppingReport.site_fire_stopping_report_id} }">
                            {{ fireStoppingReport.job_number }} | {{ fireStoppingReport.prepared_for }}
                        </router-link>
                        &raquo;
                        {{ issue.pin_number }} | {{ issue.issue_location }}        
                    </h2>
                </div>
                <div class="col-md-2">
                    <router-link :to="{ name: 'fire-stopping-report-edit-item', params: {id: parseInt(issue.site_fire_stopping_report_item_id)} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                        Edit Issue
                    </router-link>
                </div>
            </div>

            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Issue Location</h3>
                </div>
                <div class="widget-body">
                    <site-plan-marker-view
                        v-bind:markerData="markerData"
                        v-if="sitePlan"
                    ></site-plan-marker-view>
                </div>
            </div>


            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Issue Details</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                          <tr>
                              <td><strong>Issue Reference</strong></td>
                              <td>{{ issue.pin_number }}</td>
                          </tr>
                          <tr>
                              <td><strong>Location</strong></td>
                              <td>{{ issue.issue_location }}</td>
                          </tr>
                          <tr>
                              <td><strong>Operative</strong></td>
                              <td>{{ issue.operative_name !== undefined ? issue.operative_name : '' }}</td>
                          </tr>
                          <tr>
                              <td><strong>Status</strong></td>
                              <td>{{ issue.issue_status }}</td>
                          </tr>
                          <tr>
                              <td><strong>Required Fire Rating</strong></td>
                              <td>{{ issue.required_fire_rating }}</td>
                          </tr>
                          <tr>
                              <td><strong>Substrate</strong></td>
                              <td>{{ issue.substrate }}</td>
                          </tr>
                          <tr>
                              <td><strong>Construction Type</strong></td>
                              <td>{{ issue.construction_type }}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Services</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                          <tr>
                              <td><strong>Pipes?</strong></td>
                              <td>{{ issue.pipes_selected ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr v-if="issue.pipes_selected">
                              <td><strong>Pipes - Material</strong></td>
                              <td>{{ issue.pipes_material }}</td>
                          </tr>
                          <tr v-if="issue.pipes_selected">
                              <td><strong>Pipes - Size</strong></td>
                              <td>{{ issue.pipes_size }}</td>
                          </tr>
                          <tr v-if="issue.pipes_selected">
                              <td><strong>Pipes - Thermal Insulation</strong></td>
                              <td>{{ issue.pipes_thermal_insulation }}</td>
                          </tr>
                          <tr v-if="issue.pipes_selected">
                              <td><strong>Pipes - Distance of First Support</strong></td>
                              <td>{{ issue.pipes_distance_to_first_support }}</td>
                          </tr>
                          <tr v-if="issue.pipes_selected">
                              <td><strong>Pipes - Proximity to Each Other</strong></td>
                              <td>{{ issue.pipes_proximity_to_each_other }}</td>
                          </tr>
                          <tr>
                              <td><strong>Cables?</strong></td>
                              <td>{{ issue.cables_selected ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cables - Size</strong></td>
                              <td>{{ issue.cables_size }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cables - Bundles?</strong></td>
                              <td>{{ issue.cables_bundles ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cable Trays Type</strong></td>
                              <td>{{ issue.cables_trays_type }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cable Trays Size</strong></td>
                              <td>{{ issue.cables_trays_size }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cables - Support Conditions</strong></td>
                              <td>{{ issue.cables_support_conditions }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cables - Distance of First Support</strong></td>
                              <td>{{ issue.cables_distance_to_first_support }}</td>
                          </tr>
                          <tr v-if="issue.cables_selected">
                              <td><strong>Cables - Proximity to Each Other</strong></td>
                              <td>{{ issue.cables_proximity_to_each_other !== undefined ? issue.cables_proximity_to_each_other : '' }}</td>
                          </tr>
                          <tr>
                              <td><strong>Ducts/Dampers?</strong></td>
                              <td>{{ issue.ducts_selected ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Size</strong></td>
                              <td>{{ issue.ducts_size }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Manufacturer</strong></td>
                              <td>{{ issue.ducts_manufacturer }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Seal Details</strong></td>
                              <td>{{ issue.ducts_seal_details }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Support Conditions</strong></td>
                              <td>{{ issue.ducts_support_conditions }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Distance of First Support</strong></td>
                              <td>{{ issue.ducts_distance_to_first_support }}</td>
                          </tr>
                          <tr v-if="issue.ducts_selected">
                              <td><strong>Ducts/Dampers - Proximity to Each Other</strong></td>
                              <td>{{ issue.ducts_proximity_to_each_other !== undefined ? issue.ducts_proximity_to_each_other : '' }}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Opening</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                          <tr>
                              <td><strong>Size</strong></td>
                              <td>{{ issue.opening_size }}</td>
                          </tr>
                          <tr>
                              <td><strong>Depth</strong></td>
                              <td>{{ issue.opening_depth !== undefined ? issue.opening_depth : '' }}</td>
                          </tr>
                          <tr>
                              <td><strong>Preparation in Place?</strong></td>
                              <td>{{ issue.opening_preparation ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr v-if="issue.opening_preparation">
                              <td><strong>Preparation - Details</strong></td>
                              <td>{{ issue.opening_preparation_details }}</td>
                          </tr>
                          <tr v-if="issue.opening_preparation">
                              <td><strong>Preparation - Is Adequate?</strong></td>
                              <td>{{ issue.opening_preparation_adequate ? 'Yes' : 'No' }}</td>
                          </tr>
                          <tr>
                              <td><strong>Proximity to Other Elements (including walls and floors)</strong></td>
                              <td>{{ issue.opening_proximity_to_other_elements }}</td>
                          </tr>
                          <tr>
                              <td><strong>Space Adequate?</strong></td>
                              <td>{{ issue.opening_space_adequate ? 'Yes' : 'No' }}</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Work Required</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                          <tr>
                              <td><strong>Details</strong></td>
                              <td>{{ issue.work_required }}</td>
                          </tr>
                          <tr>
                              <td><strong>Faults</strong></td>
                              <td>
                                <ul v-if="issue.fire_stopping_report_item_faults">
                                    <li v-for="fault in issue.fire_stopping_report_item_faults" v-bind:key="fault.fsr_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget" v-if="preInstallationImages.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Photos Before Installation</h3>
                </div>
                <div class="widget-body">
                    <div class="row">

                        <item-image
                                v-for="fsrImage in preInstallationImages"
                                v-bind:key="fsrImage.fire_stopping_report_item_image_id"
                                v-bind:image="fsrImage"
                        ></item-image>

                    </div>
                </div>
            </div>

            <div class="widget" v-if="offlinePreInstallationImages.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Photos Before Installation - Local Images</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <template v-for="(offlineImage, index) in issue.offline_images">
                          <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-bind:key="index" v-if="offlineImage.is_pre_installation_img">
                            <img v-bind:src="offlineImage.data" class="img-fluid">
                            <div class="image-actions">
                                <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                            </div>
                            <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                          </div>
                        </template>

                    </div>
                </div>
            </div>

            <div v-if="issue.issue_status !== 'Surveyed'">

              <div class="widget">
                  <div class="widget-header bordered no-actions d-flex align-items-center">
                      <h3>Installation Details</h3>
                  </div>
                  <div class="widget-body">
                      <table class="table table-bordered">
                          <tbody>
                            <tr>
                                <td><strong>Installation Date</strong></td>
                                <td>{{ issue.installation_date | formatDate }}</td>
                            </tr>
                            <tr>
                                <td><strong>Installed By</strong></td>
                                <td>{{ issue.installed_by }}</td>
                            </tr>
                            <tr>
                                <td><strong>Products Installed</strong></td>
                                <td>
                                  <ul v-if="issue.fsr_products">
                                      <li v-for="product in issue.fsr_products" v-bind:key="product.fsr_product_id">{{ product.product_name }}</li>
                                  </ul>
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Materials Used</strong></td>
                                <td>
                                  <ul v-if="issue.fsr_materials">
                                      <li v-for="material in issue.fsr_materials" v-bind:key="material.fsr_material_id">{{ material.material_name }}</li>
                                  </ul>
                                </td>
                            </tr>
                            <tr v-if="issue.offline_engineer_signature_image == null">
                                <td><strong>Installer's Signature</strong></td>
                                <td>
                                    <span v-if="issue.engineer_signature_image == null">No signature found</span>
                                    <span v-else>Uploaded</span>
                                </td>
                            </tr>
                            <tr v-else>
                                <td><strong>Installer's Signature (offline)</strong></td>
                                <td>
                                    <img class="img-fluid" v-bind:src="issue.offline_engineer_signature_image.data">
                                </td>
                            </tr>
                          </tbody>
                      </table>
                  </div>
              </div>

              <div class="widget" v-if="postInstallationImages.length > 0">
                  <div class="widget-header bordered no-actions d-flex align-items-center">
                      <h3>Photos After Installation</h3>
                  </div>
                  <div class="widget-body">
                      <div class="row">

                          <item-image
                                  v-for="fsrImage in postInstallationImages"
                                  v-bind:key="fsrImage.fire_stopping_report_item_image_id"
                                  v-bind:image="fsrImage"
                          ></item-image>

                      </div>
                  </div>
              </div>

              <div class="widget" v-if="offlinePostInstallationImages.length > 0">
                  <div class="widget-header bordered no-actions d-flex align-items-center">
                      <h3>Photos After Installation - Local Images</h3>
                  </div>
                  <div class="widget-body">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="alert alert-warning">
                                  <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                              </div>
                          </div>
                      </div>
                      <div class="row">

                          <template v-for="(offlineImage, index) in issue.offline_images">
                            <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-bind:key="index" v-if="!offlineImage.is_pre_installation_img">
                              <img v-bind:src="offlineImage.data" class="img-fluid">
                              <div class="image-actions">
                                  <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                  <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                              </div>
                              <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                            </div>
                          </template>

                      </div>
                  </div>
              </div>

            </div>

            <div class="widget" v-if="issue.issue_status === 'Audited'">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Audit Details</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                        <tr>
                            <td><strong>Audit Date</strong></td>
                            <td>{{ issue.audit_date | formatDate }}</td>
                        </tr>
                        <tr>
                            <td><strong>Audited By</strong></td>
                            <td>{{ issue.audited_by }}</td>
                        </tr>
                        <tr>
                            <td><strong>Comments</strong></td>
                            <td>
                                <p>{{ issue.audit_comments }}</p>
                            </td>
                        </tr>
                        <tr v-if="issue.offline_sign_off_signature_image === null || issue.offline_sign_off_signature_image === undefined">
                            <td><strong>Sign-off Signature</strong></td>
                            <td>
                                <span v-if="issue.sign_off_signature_image === null || issue.sign_off_signature_image === undefined">No signature found</span>
                                <span v-else>Uploaded</span>
                            </td>
                        </tr>
                        <tr v-else>
                            <td><strong>Sign-off Signature (offline)</strong></td>
                            <td>
                                <img class="img-fluid" v-bind:src="issue.offline_sign_off_signature_image.data">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="widget has-shadow">
                        <div class="widget-body border-bottom">
                            <router-link :to="{ name: 'fire-stopping-report-add-item', params: {id: fireStoppingReport.site_fire_stopping_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                                Add Another Issue
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

  import SitePlanMarkerView from '../components/SitePlanMarkerView.vue';
  import ItemImage from '../components/ItemImage.vue';
  import ImageRotate from '@/components/mixins/ImageRotate.js'

  export default {
    components: {
      SitePlanMarkerView,
      ItemImage
    },
    mixins: [ImageRotate],
    data() {
      return {
        issue: null,
        issueLoading: true,
        fireStoppingReport: null,
        sitePlan: null,
        modifyingPhoto: false,
        preInstallationImages: [],
        postInstallationImages: []
      }
    },
    methods: {
      getIssue() {
        var vm = this;
        this.getDb(function onConnected(db) {
          try {
            var itemId = parseInt(vm.$route.params.id);
            var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
            var storeRequest = objectStore.get(itemId);
            storeRequest.onsuccess = function(event) {
              if (storeRequest.result !== undefined) {
                vm.issue = storeRequest.result;
                vm.getFireStoppingReport();
              } else {
                vm.issueLoading = false;
              }
            };
            storeRequest.onerror = function(e) {
              vm.issueLoading = false;
            }
          } catch (e) {
            console.log(e);
          }
        });
      },
      getFireStoppingReport() {
        var vm = this;
        this.getDb(function onConnected(db) {
          try {
            var objectStore = db.transaction('fire_stopping_reports').objectStore('fire_stopping_reports');
            var storeRequest = objectStore.get(vm.issue.site_fire_stopping_report_id);
            storeRequest.onsuccess = function(event) {
              if (storeRequest.result !== undefined) {
                vm.fireStoppingReport = storeRequest.result;
                vm.getSitePlan();
              } else {
                vm.issue = null;
                vm.issueLoading = false;
              }
            };
            storeRequest.onerror = function(e) {
              vm.issue = null;
              vm.issueLoading = false;
            }
          } catch (e) {
            console.log(e);
          }
        })
      },
      getSitePlan() {
        var vm = this;
        this.getDb(function onConnected(db) {
          try {
            var objectStore = db.transaction('fire_stopping_report_site_plans').objectStore('fire_stopping_report_site_plans');
            var storeRequest = objectStore.get(vm.issue.site_fire_stopping_report_site_plan_id);
            storeRequest.onsuccess = function(event) {
              if (storeRequest.result !== undefined) {
                vm.sitePlan = storeRequest.result;
                vm.loadImages();
              } else {
                vm.issue = null;
                vm.issueLoading = false;
              }
            };
            storeRequest.onerror = function(e) {
              vm.issue = null;
              vm.fireStoppingReport = null;
              vm.issueLoading = false;
            }
          } catch (e) {
            console.log(e);
          }
        })
      },
      loadImages() {
        if(this.issue.fire_stopping_report_item_images !== null && this.issue.fire_stopping_report_item_images !== undefined) {
          this.issue.fire_stopping_report_item_images.forEach(item => {
              if(item.is_pre_installation_img) {
                this.preInstallationImages.push(item);
              } else {
                this.postInstallationImages.push(item);
              }
          });
        }
        this.issueLoading = false;
      },
      removePhoto(index) {
          this.modifyingPhoto = true;
          this.issue.offline_images.splice(index, 1);
          var vm = this;
          this.getDb(function onConnectedGetDoorSets(db) {
              var putRequest = db.transaction('fire_stopping_report_items', 'readwrite')
                      .objectStore('fire_stopping_report_items').put(vm.issue);
              putRequest.onsuccess = function(event) {
                  vm.modifyingPhoto = false;
              };
              putRequest.onerror = function(event) {
                  alert("Unable to remove photo");
                  window.location = '';
              };
          });
      },
      rotatePhoto(index, degrees) {
          this.modifyingPhoto = true;
          this.rotateImage(this.issue.offline_images[index].data, degrees).then(newDataUri => {
              this.issue.offline_images[index].data = newDataUri;

              var vm = this;
              this.getDb(function onConnectedGetDoorSets(db) {
                  var putRequest = db.transaction('fire_stopping_report_items', 'readwrite')
                      .objectStore('fire_stopping_report_items').put(vm.issue);
                  putRequest.onsuccess = function(event) {
                      vm.modifyingPhoto = false;
                  };
                  putRequest.onerror = function(event) {
                      alert("Unable to rotate photo");
                      window.location = '';
                  };
              });
          }).catch(e => {
              console.log(e);
              alert('Error occurred while trying to rotate photo');
              this.modifyingPhoto = false;
          });
      }
    },
    mounted () {
        const modulesData = this.$session.get('enabled_modules');
        if(!modulesData || modulesData.indexOf('FSR') === -1) {
            this.$router.push('/');
            return;
        }
        
        this.getIssue();
    },
    computed: {
      markerData() {
        return {
          position_x: this.issue.site_plan_image_position_x,
          position_y: this.issue.site_plan_image_position_y,
          marker_number: this.issue.pin_number,
          img_src: this.sitePlan.offline_site_plan_image ? this.sitePlan.offline_site_plan_image.data : (this.cmsUrl + this.sitePlan.site_plan_image)
        }; 
      },
      offlinePreInstallationImages() {
        var imgs = [];
        this.issue.offline_images.forEach(item => {
            if(item.is_pre_installation_img) {
                imgs.push(item);
            }
        });
        return imgs;
      },
      offlinePostInstallationImages() {
        var imgs = [];
        this.issue.offline_images.forEach(item => {
            if(!item.is_pre_installation_img) {
                imgs.push(item);
            }
        });
        return imgs;
      }
    }
  }
</script>